<app-exam-header [pageTitle]="blog.title"></app-exam-header>

<!-- Hero Section -->
<section class="hero-section">
    <div class="hero-particles" id="particles-js"></div>
    <div class="container">
        <div class="row">
            <div class="col-md-8">
                <div class="hero-content">
                    <h1 class="hero-title">Our Blog</h1>
                    <div class="hero-divider"></div>
                    <!-- <p class="hero-subtitle">Stay updated with our latest news and articles</p> -->
                </div>
                
                <!-- Latest Blog -->
                <div class="latest-blog" *ngIf="blogs && blogs.length > 0">
                    <div class="pbmit-featured-wrapper">
                        <a href="blog/{{blogs[0].id}}">
                            <img [src]="siteUrl+'api/static'+blogs[0].image" class="img-fluid" alt="">
                        </a>
                        <div class="featured-badge">Featured</div>
                    </div>
                    <div class="overlay-content">
                        <div class="date-badge">
                            <span class="date-day">{{blogs[0].blog_date|date:'dd'}}</span>
                            <div class="date-divider"></div>
                            <div class="date-month-year">
                                <span class="date-month">{{blogs[0].blog_date|date:'MMM'}}</span>
                                <span class="date-year">{{blogs[0].blog_date|date:'yyyy'}}</span>
                            </div>
                        </div>
                        <div class="title-action-row">
                            <h3 class="pbmit-post-title">
                                <a href="blog/{{blogs[0].id}}">{{blogs[0].title}}</a>
                            </h3>
                            <div class="pbmit-read-more-link">
                                <a href="blog/{{blogs[0].id}}">
                                    <span>Read More</span>
                                    <i class="fa fa-arrow-right"></i>
                                </a>
                            </div>
                        </div>
                        <div class="pbmit-entry-content">
                            <!-- <p [innerHTML]="blogs[0].short_description"></p> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <aside class="sidebar hero-sidebar d-none d-md-block">
                    <aside class="widget widget-recent-post">
                        <h2 class="widget-title">Recent Blogs</h2>
                        <div class="widget-divider"></div>
                        <ul class="recent-post-list">
                            <li class="recent-post-list-li" *ngFor="let blog of recentBlogs"> 
                                <a class="recent-post-thum" href="blog/{{blog.id}}">
                                    <img [src]="siteUrl+'api/static'+blog.image" class="img-fluid w-100" alt="">
                                </a>
                                <div class="media-body">
                                    <span class="post-title">
                                        <a href="blog/{{blog.id}}">{{blog.title}}</a>
                                    </span>
                                    <span class="post-date">
                                        <i class="fa fa-calendar-alt"></i> {{blog.blog_date | date:'MMM d, yyyy'}}
                                    </span>
                                </div> 
                            </li>
                        </ul>
                    </aside>
                </aside>
                
                <!-- Mobile Recent Blogs (Horizontal Scrolling) -->
                <div class="d-md-none mobile-recent-blogs mt-4">
                    <h4 class="mobile-widget-title">Recent Blogs</h4>
                    <div class="widget-divider"></div>
                    <div class="mobile-blogs-scroll">
                        <div class="mobile-blog-item" *ngFor="let blog of recentBlogs">
                            <a href="blog/{{blog.id}}">
                                <img [src]="siteUrl+'api/static'+blog.image" class="img-fluid" alt="">
                                <div class="mobile-blog-title">{{blog.title}}</div>
                                <div class="mobile-blog-date">
                                    <i class="fa fa-calendar-alt"></i> {{blog.blog_date | date:'MMM d, yyyy'}}
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Blog Details -->
<section class="blog-details-section">
    <div class="overlay-background"></div>
    <div class="container-fluid px-4">
        <div class="section-header">
            <h2 class="section-title">All Blogs</h2>
            <div class="section-divider"></div>
            <p class="section-subtitle">Explore our collection of insightful content</p>
        </div>
        
        <div class="row">
            <!-- Main Content Column -->
            <div class="col-lg-9 blog-right-col" style="width: 75vw;">
                <!-- Blog Grid -->
                <div class="blog-grid">
                    <!-- Blog Card -->
                    <div class="pbmit-blog-classic" *ngFor="let blog of blogs.slice(1)">
                        <!-- Blog Image Area -->
                        <div class="pbmit-featured-img-wrapper">
                            <!-- Date Badge -->
                            <div class="date-badge">
                                <span class="date-day">{{blog.blog_date|date:'dd'}}</span>
                                <div class="date-divider"></div>
                                <div class="date-month-year">
                                    <span class="date-month">{{blog.blog_date|date:'MMM'}}</span>
                                    <span class="date-year">{{blog.blog_date|date:'yyyy'}}</span>
                                </div>
                            </div>
                            <!-- Featured Image -->
                            <div class="pbmit-featured-wrapper">
                                <a href="blog/{{blog.id}}" class="blog-image-container">
                                    <img [src]="siteUrl+'api/static'+blog.image" class="img-fluid blog-image" alt="{{blog.title}}">
                                </a>
                            </div>
                        </div>
                        
                        <!-- Blog Content Area - Enhanced for better visibility -->
                        <div class="pbmit-blog-classic-inner">
                            <!-- Blog Title - Enhanced -->
                            <h3 class="pbmit-post-title enhanced-title">
                                <a href="blog/{{blog.id}}">{{blog.title}}</a>
                            </h3>
                            
                            <!-- Blog Content - Enhanced -->
                            <div class="pbmit-entry-content enhanced-content">
                                <p [innerHTML]="blog.short_description"></p>
                                <div class="pbmit-read-more-link" style="text-align: right; margin-bottom: 0;">
                                    <a href="blog/{{blog.id}}">
                                        <span>Read More</span>
                                        <i class="fa fa-arrow-right"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <!-- Sidebar Column -->
            <div class="col-lg-3 blog-left-col" style="width: 25vw;">
                <aside class="sidebar">
                    <!-- Categories Widget -->
                    <aside class="widget widget-categories">
                        <h2 class="widget-title">Categories</h2>
                        <div class="widget-divider"></div>
                        <ul>
                            <li *ngFor="let category of categoryList">
                                <a href="javascript:void(0)" (click)="filterByCategory(category)">
                                    <div>{{category}}</div>
                                    <span class="category-count">{{categories[category]}}</span>
                                </a>
                            </li>
                        </ul>
                    </aside>
                    
                    <!-- Tags Widget -->
                    <aside class="widget widget-tags">
                        <h2 class="widget-title">Popular Tags</h2>
                        <div class="widget-divider"></div>
                        <div class="tagcloud">
                            <a href="javascript:void(0)" *ngFor="let category of categoryList.slice(0, 8)" (click)="filterByCategory(category)">{{category}}</a>
                        </div>
                    </aside>
                </aside>
            </div>
        </div>
    </div>
</section>
<!-- Blog Details End -->

<app-exam-footer></app-exam-footer>